import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getImagePath } from '../utils/imagePath';

const Election2026 = () => {
  const [activeTab, setActiveTab] = useState('timetable');
  const [committeeSubTab, setCommitteeSubTab] = useState('secretariat');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const timetable = [
    { date: '18 May', activity: 'Announcement of Electoral Committee (ELCO) and Elections Timetable & Guidelines', highlight: false },
    { date: '22 May', activity: 'Opening of Nominations', highlight: true },
    { date: '28 May', activity: 'Close of Nominations', highlight: false },
    { date: '29 - 31 May', activity: 'Screening & Verification', highlight: false },
    { date: '1 Jun', activity: 'Publication of Initial Candidates\' List', highlight: false },
    { date: '2 – 3 Jun', activity: 'Petitioning', highlight: false },
    { date: '4 Jun', activity: 'Publication of Final Candidates\' List', highlight: false },
    { date: '4 - 12 Jun', activity: 'Campaign Period', highlight: true },
    { date: '13 Jun', activity: 'Candidates Forum / Townhall', highlight: false },
    { date: '14 Jun', activity: 'Final Election Notice', highlight: false },
    { date: '16 Jun', activity: 'Election Day', highlight: true },
    { date: '16 Jun', activity: 'Announcement of Results', highlight: false },
    { date: 'First week of July', activity: 'Transition & Handover Support', highlight: false }
  ];

  const elcoMembers = {
    chairman: {
      name: 'Samson Adeosun',
      role: 'Chairman',
      email: 'samson.adeosun@nlng.com',
      description: 'Leading the 2026 Electoral Committee and accountable for the integrity, fairness and timely conduct of the entire election cycle.',
      initials: 'SA',
      image: 'SA_RA.jpg'
    },
    secretariat: [
      { name: 'Abdulmalik Ibrahim', role: 'Secretary', email: 'abdulmalik.ibrahim@nlng.com', initials: 'AI' },
      { name: 'Mariam Ezekwesili', role: 'Assistant Secretary', email: 'mariam.ezekwesili@nlng.com', initials: 'ME' },
      { name: 'Lorraine Ichoku', role: 'Secretariat', email: 'lorraine.ichoku@nlng.com', initials: 'LI' },
      { name: 'Emmanuel Nwachukwu', role: 'Secretariat', email: 'emmanuel.nwachukwu@nlng.com', initials: 'EN' }
    ],
    committee: [
      { name: 'Kenneth Ezugwu', role: 'Committee Member', email: 'kenneth.ezugwu@nlng.com', initials: 'KE' },
      { name: 'Ikenna Ikonta', role: 'Committee Member', email: 'ikenna.ikonta@nlng.com', initials: 'II' },
      { name: 'Oluwafolakemi Olumuyiwa', role: 'Committee Member', email: 'folakemi.olumuyiwa@nlng.com', initials: 'OO' },
      { name: 'Mrs. Victoria Obakpolor', role: 'Committee Member', email: 'obakpolor@nlng.com', initials: 'OB' }
    ],
    publication: [
      { name: 'Oyegbami Oludare', role: 'Publication', email: 'oyegbami.oludare@nlng.com', initials: 'OO' },
      { name: 'Louis Osakwe', role: 'Publication', email: 'louis.osakwe@nlng.com', initials: 'LO' },
      { name: 'Eno-Obong Ukpong', role: 'Publication', email: 'eno.ukpong@nlng.com', initials: 'EU' },
      { name: 'Farouk Shagari', role: 'Publication', email: 'farouk.shagari@nlng.com', initials: 'FS' }
    ]
  };

  const guidelines = [
    {
      num: 1,
      title: 'Who can contest?',
      content: [
        'All Full Members may contest, except where Direct Staff / Secondee restrictions apply'
      ]
    },
    {
      num: 2,
      title: 'Who can vote?',
      content: [
        '• All Full Members - NLNG / NSML / RAIS Direct Staff and Secondees based on Bonny',
        '• Registered spouses of Full Members who are RA residents',
        '• Associate Members do not vote and cannot contest'
      ]
    },
    {
      num: 3,
      title: 'How will voting happen?',
      content: [
        '• Voting will be conducted electronically via an authenticated, auditable online platform.',
        '• Login credentials and the voting window will be communicated by ELCO closer to election day.'
      ]
    },
    {
      num: 4,
      title: 'Restrictions to note',
      content: [
        '• Two consecutive terms in the same position = not eligible to contest that position again',
        '• ELCO members and their immediate families cannot contest',
        '• HRE/2 unit members cannot contest',
        '• One candidate, one position only',
        '• All winners are decided by simple majority. Ties trigger a re-vote.'
      ]
    },
    {
      num: 5,
      title: 'Conflict of Interest Declaration',
      content: [
        '• Per the 2026 AGM amendment, every elected RCEC member must sign a Conflict of Interest Declaration and Code of Conduct Acknowledgement Form within 14 days of assumption of office.'
      ]
    },
    {
      num: 6,
      title: 'Positions available',
      content: [
        'Eight (8) positions open for contest:',
        '• Vice President',
        '• General Secretary',
        '• Assistant General Secretary',
        '• Director of Socials',
        '• Director of Sports & Wellness',
        '• Director of Culture',
        '• Director of Technicals',
        '• Director, International Community'
      ]
    }
  ];

  // ========== FIXED: PDF FUNCTIONS USING PUBLIC FOLDER ==========
  const handleViewPDF = (fileType) => {
    let filePath = '';
    let fileName = '';
    
    if (fileType === 'guidelines') {
      filePath = '/2026_Election_Guidelines.pdf';
      fileName = '2026_Election_Guidelines.pdf';
    } else if (fileType === 'constitution') {
      filePath = '/RA_Club_Constitution_2026.pdf';
      fileName = 'RA_Club_Constitution_2026.pdf';
    } else {
      console.error('Unknown file type:', fileType);
      alert('Unknown file type requested');
      return;
    }
    
    console.log(`Opening PDF: ${fileName} from ${filePath}`);
    
    // Direct open from public folder - should work perfectly
    window.open(filePath, '_blank');
  };

  const handleDownloadPDF = (fileType) => {
    let filePath = '';
    let fileName = '';
    
    if (fileType === 'guidelines') {
      filePath = '/2026_Election_Guidelines.pdf';
      fileName = '2026_Election_Guidelines.pdf';
    } else if (fileType === 'constitution') {
      filePath = '/RA_Club_Constitution_2026.pdf';
      fileName = 'RA_Club_Constitution_2026.pdf';
    } else {
      console.error('Unknown file type:', fileType);
      alert('Unknown file type requested');
      return;
    }
    
    console.log(`Downloading: ${fileName}`);
    
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.2
      }
    }
  };

  const glowOnHover = {
    rest: { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
    hover: { boxShadow: "0 20px 40px rgba(34,197,94,0.15), 0 0 0 2px rgba(34,197,94,0.2)", transition: { duration: 0.2 } }
  };

  const committeeSubTabs = [
    { id: 'secretariat', label: 'Secretariat', icon: 'fa-building', members: elcoMembers.secretariat, color: '#166534' },
    { id: 'committee', label: 'Committee', icon: 'fa-handshake', members: elcoMembers.committee, color: '#22c55e' },
    { id: 'publication', label: 'Publication', icon: 'fa-newspaper', members: elcoMembers.publication, color: '#4ade80' }
  ];

  return (
    <div className="election-page">
      <div className="bg-animation">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <motion.section 
        className="election-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <motion.span 
              className="hero-eyebrow"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <span className="pulse-dot"></span>
              RA Club · Election Season 2026
            </motion.span>
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              Shape the next chapter of the <span className="text-gradient">RA Club</span>
            </motion.h1>
            <motion.p 
              className="hero-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
            >
              The tenure of the current RCEC ends in 2026. The Electoral Committee (ELCO) 
              is now conducting elections into ten executive positions. Read the full guidelines, 
              check the timetable and pick up a nomination form right here.
            </motion.p>
            <motion.div 
              className="hero-actions"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.5 }}
            >
              <motion.button 
                whileHover={{ scale: 1.05, y: -3, boxShadow: "0 10px 25px -5px rgba(34,197,94,0.4)" }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleViewPDF('guidelines')}
                className="btn btn-primary"
              >
                <i className="fas fa-eye"></i> View Full Guidelines
                <motion.span className="btn-glow" />
              </motion.button>
     
<motion.button 
  whileHover={{ scale: 1.05, y: -3, borderColor: "#22c55e", color: "#4ade80", backgroundColor: "rgba(34,197,94,0.1)" }}
  whileTap={{ scale: 0.98 }}
  onClick={() => window.open('https://forms.cloud.microsoft/pages/responsepage.aspx?id=OQ5hJ6_hxkKyD4DKjIV5xsXTxNbd7gJOspkFWdMHjpdUNkFTQTVCREk5WE9TMjBVMUowUkNSNkRZSS4u&route=shorturl', '_blank')}
  className="btn btn-outline"
>
  <i className="fas fa-file-alt"></i> Nomination Form
</motion.button>
              <motion.button 
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleViewPDF('constitution')}
                className="btn btn-secondary"
              >
                <i className="fas fa-gavel"></i> View Constitution
              </motion.button>  
            </motion.div>
          </motion.div>
        </div>
        <motion.div 
          className="hero-wave"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.2, delay: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
        />
      </motion.section>

      <motion.div 
        className="info-strip"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
      >
        <div className="container">
          <div className="info-grid">
            {[
              { label: 'Nominations Open', value: '22 - 28 May 2026', icon: 'fa-calendar-plus' },
              { label: 'Campaign Period', value: '4 - 12 Jun 2026', icon: 'fa-bullhorn' },
              { label: 'Election Day', value: '16 June 2026', icon: 'fa-check-circle' },
              { label: 'Mode of Voting', value: 'Electronic Ballot', icon: 'fa-laptop' }
            ].map((item, idx) => (
              <motion.div 
                key={idx}
                className="info-tile"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 + (idx * 0.1) }}
                whileHover={{ scale: 1.05, y: -8, borderColor: "#22c55e", backgroundColor: "white", boxShadow: "0 15px 30px -12px rgba(34,197,94,0.15)" }}
              >
                <motion.div className="info-icon" whileHover={{ rotate: 360, transition: { duration: 0.6 } }}>
                  <i className={`fas ${item.icon}`}></i>
                </motion.div>
                <div>
                  <span className="info-label">{item.label}</span>
                  <span className="info-value">{item.value}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>

      <motion.div 
        className={`election-tabs ${scrolled ? 'scrolled' : ''}`}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.9 }}
      >
        <div className="container">
          <div className="tabs-nav">
            {[
              { id: 'timetable', icon: 'fa-calendar-alt', label: 'Timetable' },
              { id: 'guidelines', icon: 'fa-gavel', label: 'Guidelines' },
              { id: 'committee', icon: 'fa-users', label: 'Committee' }
            ].map((tab) => (
              <motion.button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.98 }}
              >
                <i className={`fas ${tab.icon}`}></i>
                <span>{tab.label}</span>
                {activeTab === tab.id && <motion.div className="tab-indicator" layoutId="tabIndicator" />}
              </motion.button>
            ))}
          </div>
        </div>
      </motion.div>

      <section className="election-content">
        <div className="container">
          <AnimatePresence mode="wait">
            {activeTab === 'timetable' && (
              <motion.div
                key="timetable"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -40 }}
                transition={{ duration: 0.5 }}
                className="timetable-section"
              >
                <motion.div 
                  className="section-header"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <motion.div 
                    className="section-badge"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.4, type: "spring" }}
                  >
                    <i className="fas fa-calendar-alt"></i> Schedule
                  </motion.div>
                  <h2>Elections <span className="text-green">Timetable</span></h2>
                  <motion.div className="section-line" />
                  <p>Confirmed dates from ELCO. Binding on candidates, voters and both the outgoing and incoming RCEC.</p>
                </motion.div>

                <motion.div 
                  className="timetable-wrapper"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  variants={glowOnHover}
                  whileHover="hover"
                >
                  <table className="timetable">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Activity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timetable.map((item, idx) => (
                        <motion.tr 
                          key={idx} 
                          className={item.highlight ? 'highlight-row' : ''}
                          initial={{ opacity: 0, x: -30 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.4, delay: idx * 0.03 }}
                          whileHover={{ scale: 1.01, backgroundColor: "rgba(34,197,94,0.08)", transition: { duration: 0.1 } }}
                        >
                          <td className="date-cell"><span>{item.date}</span></td>
                          <td className="activity-cell">{item.activity}</td>
                        </motion.tr>
                      ))}
                    </tbody>
                  </table>
                </motion.div>
              </motion.div>
            )}

            {activeTab === 'guidelines' && (
              <motion.div
                key="guidelines"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -40 }}
                transition={{ duration: 0.5 }}
                className="guidelines-section"
              >
                <motion.div 
                  className="section-header"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <motion.div 
                    className="section-badge"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.4, type: "spring" }}
                  >
                    <i className="fas fa-gavel"></i> Rules & Regulations
                  </motion.div>
                  <h2>Key <span className="text-green">Guidelines</span></h2>
                  <motion.div className="section-line" />
                  <p>Summary only - the full document is the binding reference.</p>
                </motion.div>

                <motion.div 
                  className="guidelines-grid"
                  variants={staggerContainer}
                  initial="hidden"
                  animate="visible"
                >
                  {guidelines.map((guide, idx) => (
                    <motion.div 
                      key={idx} 
                      className="guideline-card"
                      variants={fadeInUp}
                      whileHover="hover"
                      initial="rest"
                      animate="rest"
                    >
                      <motion.div 
                        className="guideline-number"
                        whileHover={{ scale: 1.15, rotate: 5, backgroundColor: "#22c55e", color: "white" }}
                      >
                        {guide.num}
                      </motion.div>
                      <motion.h3>{guide.title}</motion.h3>
                      <div className="guideline-content">
                        {guide.content.map((item, i) => (
                          <motion.p 
                            key={i}
                            initial={{ opacity: 0, x: -15 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3, delay: (idx * 0.05) + (i * 0.02) }}
                          >
                            {item.startsWith('•') ? (
                              <><span className="bullet-point">▹</span> {item.substring(1)}</>
                            ) : item.startsWith('Eight') ? (
                              <><strong>{item}</strong></>
                            ) : !item.startsWith('•') && item.includes(':') ? (
                              <><strong>{item.split(':')[0]}:</strong> {item.split(':')[1]}</>
                            ) : (
                              item
                            )}
                          </motion.p>
                        ))}
                      </div>
                    </motion.div>
                  ))}
                </motion.div>

                <motion.div 
                  className="download-section"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <motion.button 
                      whileHover={{ scale: 1.05, y: -5, boxShadow: "0 15px 35px -10px rgba(34,197,94,0.4)" }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => handleViewPDF('guidelines')}
                      className="btn btn-primary btn-large"
                    >
                      <i className="fas fa-eye"></i> View Full Guidelines PDF
                      <motion.span className="btn-glow" />
                    </motion.button>
           
                  </div>
                </motion.div>
              </motion.div>
            )}

            {activeTab === 'committee' && (
              <motion.div
                key="committee"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -40 }}
                transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
                className="committee-section"
              >
                <motion.div 
                  className="section-header"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <motion.div 
                    className="section-badge"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.4, type: "spring" }}
                  >
                    <i className="fas fa-users"></i> Leadership
                  </motion.div>
                  <h2>The Electoral Committee <span className="text-green">(ELCO)</span></h2>
                  <motion.div className="section-line" />
                  <p>Appointed by Senior Leadership under Article IV of the RA Club Constitution to organise, conduct and oversee the 2026 election.</p>
                </motion.div>

                <motion.div 
                  className="chairman-card"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.1, type: "spring", stiffness: 100 }}
                  whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}
                >
                  <motion.div 
                    className="chairman-avatar"
                    initial={{ rotate: -10, scale: 0.9 }}
                    animate={{ rotate: 0, scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2, type: "spring" }}
                    whileHover={{ scale: 1.05, rotate: 5 }}
                  >
                    {elcoMembers.chairman.image ? (
                      <motion.img 
                        src={getImagePath(elcoMembers.chairman.image)} 
                        alt={elcoMembers.chairman.name}
                        className="chairman-image"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                      />
                    ) : (
                      <motion.div 
                        className="avatar-placeholder large"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                      >
                        <span>{elcoMembers.chairman.initials}</span>
                      </motion.div>
                    )}
                  </motion.div>
                  <motion.div 
                    className="chairman-info"
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  >
                    <motion.span 
                      className="role-badge"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 0.4 }}
                    >
                      <i className="fas fa-crown"></i> Lead · Chairman
                    </motion.span>
                    <motion.h3
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 0.5 }}
                    >
                      {elcoMembers.chairman.name}
                    </motion.h3>
                    <motion.p
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5, delay: 0.6 }}
                    >
                      {elcoMembers.chairman.description}
                    </motion.p>
                    <motion.a 
                      href={`mailto:${elcoMembers.chairman.email}`} 
                      className="email-link"
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.7 }}
                      whileHover={{ x: 5, backgroundColor: "#4ade80", color: "#0a2e1f" }}
                    >
                      <i className="fas fa-envelope"></i> {elcoMembers.chairman.email}
                    </motion.a>
                  </motion.div>
                </motion.div>

                <div className="committee-sub-tabs">
                  {committeeSubTabs.map((tab) => (
                    <motion.button
                      key={tab.id}
                      className={`sub-tab-btn ${committeeSubTab === tab.id ? 'active' : ''}`}
                      onClick={() => setCommitteeSubTab(tab.id)}
                      whileHover={{ scale: 1.02, y: -2 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <i className={`fas ${tab.icon}`}></i>
                      <span>{tab.label}</span>
                      {committeeSubTab === tab.id && (
                        <motion.div 
                          className="sub-tab-indicator" 
                          layoutId="subTabIndicator"
                          transition={{ type: "spring", stiffness: 500, damping: 30 }}
                        />
                      )}
                    </motion.button>
                  ))}
                </div>

                <div className="sub-tab-panels">
                  <AnimatePresence mode="wait">
                    {committeeSubTab === 'secretariat' && (
                      <motion.div
                        key="secretariat"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                        className="sub-tab-panel"
                      >
                        <div className="panel-header">
                          <h3><i className="fas fa-building"></i> Secretariat</h3>
                          <p>Managing the administrative backbone of the 2026 election process.</p>
                        </div>
                        <motion.div 
                          className="members-grid"
                          variants={staggerContainer}
                          initial="hidden"
                          animate="visible"
                        >
                          {committeeSubTabs.find(t => t.id === 'secretariat').members.map((member, idx) => (
                            <motion.div 
                              key={idx} 
                              className="member-card"
                              variants={fadeInUp}
                              whileHover="hover"
                              initial="rest"
                              animate="rest"
                            >
                              <motion.div 
                                className="member-avatar"
                                whileHover={{ scale: 1.15, rotate: 5, backgroundColor: "#22c55e" }}
                              >
                                <span>{member.initials}</span>
                              </motion.div>
                              <div className="member-info">
                                <h4>{member.name}</h4>
                                <p>{member.role}</p>
                                <motion.a 
                                  href={`mailto:${member.email}`} 
                                  className="small-email"
                                  whileHover={{ x: 5, color: "#22c55e" }}
                                >
                                  <i className="fas fa-envelope"></i> Contact
                                </motion.a>
                              </div>
                            </motion.div>
                          ))}
                        </motion.div>
                      </motion.div>
                    )}

                    {committeeSubTab === 'committee' && (
                      <motion.div
                        key="committee-members"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                        className="sub-tab-panel"
                      >
                        <div className="panel-header">
                          <h3><i className="fas fa-handshake"></i> Committee Members</h3>
                          <p>Dedicated members ensuring a fair and transparent election process.</p>
                        </div>
                        <motion.div 
                          className="members-grid"
                          variants={staggerContainer}
                          initial="hidden"
                          animate="visible"
                        >
                          {committeeSubTabs.find(t => t.id === 'committee').members.map((member, idx) => (
                            <motion.div 
                              key={idx} 
                              className="member-card"
                              variants={fadeInUp}
                              whileHover="hover"
                              initial="rest"
                              animate="rest"
                            >
                              <motion.div 
                                className="member-avatar"
                                whileHover={{ scale: 1.15, rotate: 5, backgroundColor: "#22c55e" }}
                              >
                                <span>{member.initials}</span>
                              </motion.div>
                              <div className="member-info">
                                <h4>{member.name}</h4>
                                <p>{member.role}</p>
                                <motion.a 
                                  href={`mailto:${member.email}`} 
                                  className="small-email"
                                  whileHover={{ x: 5, color: "#22c55e" }}
                                >
                                  <i className="fas fa-envelope"></i> Contact
                                </motion.a>
                              </div>
                            </motion.div>
                          ))}
                        </motion.div>
                      </motion.div>
                    )}

                    {committeeSubTab === 'publication' && (
                      <motion.div
                        key="publication"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                        className="sub-tab-panel"
                      >
                        <div className="panel-header">
                          <h3><i className="fas fa-newspaper"></i> Publication Team</h3>
                          <p>Responsible for all official communications and announcements.</p>
                        </div>
                        <motion.div 
                          className="members-grid"
                          variants={staggerContainer}
                          initial="hidden"
                          animate="visible"
                        >
                          {committeeSubTabs.find(t => t.id === 'publication').members.map((member, idx) => (
                            <motion.div 
                              key={idx} 
                              className="member-card"
                              variants={fadeInUp}
                              whileHover="hover"
                              initial="rest"
                              animate="rest"
                            >
                              <motion.div 
                                className="member-avatar"
                                whileHover={{ scale: 1.15, rotate: 5, backgroundColor: "#22c55e" }}
                              >
                                <span>{member.initials}</span>
                              </motion.div>
                              <div className="member-info">
                                <h4>{member.name}</h4>
                                <p>{member.role}</p>
                                <motion.a 
                                  href={`mailto:${member.email}`} 
                                  className="small-email"
                                  whileHover={{ x: 5, color: "#22c55e" }}
                                >
                                  <i className="fas fa-envelope"></i> Contact
                                </motion.a>
                              </div>
                            </motion.div>
                          ))}
                        </motion.div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </section>

      <motion.section 
        className="contact-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.div 
            className="section-header center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <motion.div 
              className="section-badge"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, type: "spring" }}
            >
              <i className="fas fa-envelope"></i> Get in Touch
            </motion.div>
            <h2>Contact the <span className="text-green">Electoral Committee</span></h2>
            <motion.div className="section-line" />
            <p>Questions on eligibility, the nomination form, or any part of the process? Reach out directly.</p>
          </motion.div>

          <motion.div 
            className="contact-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              { name: 'Samson Adeosun', role: 'ELCO Chairman', email: 'samson.adeosun@nlng.com', initials: 'SA', image: 'SA_RA Club.jpg' },
              { name: 'Abdulmalik Ibrahim', role: 'ELCO Secretary', email: 'abdulmalik.ibrahim@nlng.com', initials: 'AI', image: null },
              { name: 'Emmanuel Nwachukwu', role: 'ELCO Member', email: 'emmanuel.nwachukwu@nlng.com', initials: 'EN', image: null }
            ].map((contact, idx) => (
              <motion.div 
                key={idx}
                className="contact-card"
                variants={fadeInUp}
                whileHover="hover"
                initial="rest"
                animate="rest"
              >
                <motion.div 
                  className="contact-avatar"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                >
                  {contact.image ? (
                    <img 
                      src={getImagePath(contact.image)} 
                      alt={contact.name}
                      className="contact-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<span>${contact.initials}</span>`;
                      }}
                    />
                  ) : (
                    <span>{contact.initials}</span>
                  )}
                </motion.div>
                <motion.h4>{contact.name}</motion.h4>
                <p className="contact-role">{contact.role}</p>
                <motion.a 
                  href={`mailto:${contact.email}`} 
                  className="contact-email"
                  whileHover={{ x: 8, backgroundColor: "#22c55e", color: "white" }}
                >
                  <i className="fas fa-envelope"></i> {contact.email}
                </motion.a>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.section>

      <style jsx>{`
        .election-page {
          background: #ffffff;
          overflow-x: hidden;
          position: relative;
        }

        .bg-animation {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: 0;
          overflow: hidden;
        }

        .gradient-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.4;
          animation: float 20s infinite ease-in-out;
        }

        .orb-1 {
          width: 400px;
          height: 400px;
          background: rgba(34, 197, 94, 0.15);
          top: -100px;
          right: -100px;
        }
        .orb-2 {
          width: 300px;
          height: 300px;
          background: rgba(22, 101, 52, 0.1);
          bottom: 20%;
          left: -80px;
          animation-delay: -5s;
        }
        .orb-3 {
          width: 500px;
          height: 500px;
          background: rgba(34, 197, 94, 0.08);
          bottom: -150px;
          right: 20%;
          animation-delay: -10s;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -30px) scale(1.05); }
          66% { transform: translate(-20px, 20px) scale(0.95); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.3); }
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 2;
        }

        @media (max-width: 768px) {
          .container { padding: 0 20px; }
        }

        @media (max-width: 480px) {
          .container { padding: 0 16px; }
        }

        .election-hero {
          position: relative;
          background: linear-gradient(135deg, #0a2e1f 0%, #0f3d24 50%, #0a2e1f 100%);
          padding: 140px 0 100px;
          color: white;
          overflow: hidden;
        }

        @media (max-width: 768px) {
          .election-hero { padding: 100px 0 70px; }
        }

        @media (max-width: 480px) {
          .election-hero { padding: 80px 0 60px; }
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 30% 40%, rgba(34, 197, 94, 0.15), transparent 70%);
          pointer-events: none;
        }

        .hero-wave {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 80px;
          background: linear-gradient(135deg, transparent 50%, white 50%);
          transform-origin: left;
        }

        @media (max-width: 768px) {
          .hero-wave { height: 50px; }
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
        }

        .hero-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 6px 16px;
          background: rgba(34, 197, 94, 0.15);
          border: 1px solid rgba(34, 197, 94, 0.3);
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #bbf7d0;
          margin-bottom: 24px;
        }

        .pulse-dot {
          width: 8px;
          height: 8px;
          background: #4ade80;
          border-radius: 50%;
          display: inline-block;
          animation: pulse 1.5s infinite;
        }

        .hero-title {
          font-size: 58px;
          font-weight: 800;
          margin: 0 0 24px;
          line-height: 1.15;
        }

        @media (max-width: 768px) {
          .hero-title { font-size: 40px; }
        }

        @media (max-width: 480px) {
          .hero-title { font-size: 32px; }
        }

        .text-gradient {
          background: linear-gradient(135deg, #4ade80, #22c55e, #166534);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }

        .hero-subtitle {
          font-size: 18px;
          color: rgba(255,255,255,0.85);
          margin-bottom: 40px;
          line-height: 1.6;
        }

        @media (max-width: 768px) {
          .hero-subtitle { font-size: 16px; }
        }

        .hero-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
        }

        @media (max-width: 640px) {
          .hero-actions { flex-direction: column; width: 100%; }
          .hero-actions .btn { width: 100%; justify-content: center; }
        }

        .btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          padding: 14px 32px;
          border-radius: 40px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: none;
          position: relative;
          overflow: hidden;
          z-index: 1;
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .btn {
            white-space: normal;
            word-break: break-word;
            text-align: center;
            padding: 12px 20px;
            font-size: 13px;
          }
        }

        .btn-primary {
          background: transparent;
          border: 1.5px solid #22c55e;
          color: #4ade80;
        }

        .btn-primary .btn-glow {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          transition: left 0.5s;
          z-index: -1;
        }

        .btn-primary:hover .btn-glow { left: 100%; }
        .btn-primary:hover {
          background: linear-gradient(135deg, #22c55e, #166534);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(34, 197, 94, 0.4);
          border-color: transparent;
        }

        .btn-outline {
          background: transparent;
          border: 1.5px solid rgba(255, 255, 255, 0.3);
          color: rgba(255, 255, 255, 0.9);
        }
        .btn-outline:hover {
          border-color: #22c55e;
          background: #22c55e;
          color: white;
          transform: translateY(-2px);
        }

        .btn-secondary {
          background: rgba(34, 197, 94, 0.15);
          border: 1.5px solid #22c55e;
          color: #4ade80;
        }
        .btn-secondary:hover {
          background: #22c55e;
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px -8px rgba(34, 197, 94, 0.4);
        }

        .btn-large { padding: 16px 40px; font-size: 16px; }
        @media (max-width: 768px) { .btn-large { padding: 14px 24px; font-size: 14px; } }

        .info-strip {
          background: #ffffff;
          border-bottom: 1px solid #e5e9e6;
          padding: 40px 0;
        }

        @media (max-width: 768px) { .info-strip { padding: 30px 0; } }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 32px;
        }

        @media (max-width: 768px) {
          .info-grid { grid-template-columns: repeat(2, 1fr); gap: 16px; }
        }
        @media (max-width: 480px) { .info-grid { grid-template-columns: 1fr; } }

        .info-tile {
          display: flex;
          align-items: center;
          gap: 18px;
          padding: 16px 24px;
          background: #f8faf8;
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        @media (max-width: 768px) { .info-tile { padding: 12px 16px; gap: 14px; } }

        .info-tile:hover {
          border-color: #22c55e;
          background: white;
        }

        .info-icon {
          width: 52px;
          height: 52px;
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #166534;
          font-size: 24px;
        }

        @media (max-width: 768px) { .info-icon { width: 44px; height: 44px; font-size: 20px; } }

        .info-label {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #9ca3af;
          display: block;
          margin-bottom: 4px;
        }

        .info-value {
          font-size: 18px;
          font-weight: 800;
          color: #111827;
        }

        @media (max-width: 768px) { .info-value { font-size: 14px; } }

        .election-tabs {
          background: white;
          border-bottom: 1px solid #e5e9e6;
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(255,255,255,0.98);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .election-tabs.scrolled { box-shadow: 0 4px 20px rgba(0,0,0,0.08); }

        .tabs-nav {
          display: flex;
          gap: 12px;
          padding: 20px 0;
        }

        @media (max-width: 768px) {
          .tabs-nav {
            gap: 8px;
            padding: 12px 0;
            overflow-x: auto;
            flex-wrap: nowrap;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: thin;
          }
          .tabs-nav::-webkit-scrollbar { height: 3px; }
          .tabs-nav::-webkit-scrollbar-track { background: #f0fdf4; border-radius: 10px; }
          .tabs-nav::-webkit-scrollbar-thumb { background: #22c55e; border-radius: 10px; }
        }

        .tab-btn {
          padding: 10px 28px;
          background: transparent;
          border: none;
          font-size: 14px;
          font-weight: 600;
          color: #666666;
          cursor: pointer;
          border-radius: 40px;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 10px;
          position: relative;
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .tab-btn {
            padding: 8px 20px;
            font-size: 13px;
            flex: 0 0 auto;
          }
          .tab-btn i { font-size: 13px; }
        }

        @media (max-width: 480px) {
          .tab-btn { padding: 8px 16px; font-size: 12px; gap: 6px; }
          .tab-btn i { font-size: 12px; }
        }

        .tab-btn:hover {
          color: #166534;
          background: #f0fdf4;
        }

        .tab-btn.active {
          background: #166534;
          color: white;
        }

        .tab-indicator {
          position: absolute;
          bottom: -20px;
          left: 0;
          right: 0;
          height: 3px;
          background: #22c55e;
          border-radius: 3px;
        }

        @media (max-width: 768px) {
          .tab-indicator { bottom: -12px; height: 2px; }
        }

        .election-content { padding: 80px 0; background: white; }
        @media (max-width: 768px) { .election-content { padding: 50px 0; } }

        .section-header { text-align: center; margin-bottom: 64px; }
        @media (max-width: 768px) { .section-header { margin-bottom: 40px; } }

        .section-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 16px;
          background: #f0fdf4;
          border-radius: 40px;
          font-size: 12px;
          font-weight: 600;
          color: #166534;
          margin-bottom: 20px;
        }

        .section-header h2 {
          font-size: 42px;
          font-weight: 800;
          margin-bottom: 20px;
          color: #111827;
        }

        @media (max-width: 768px) { .section-header h2 { font-size: 32px; } }
        @media (max-width: 480px) { .section-header h2 { font-size: 28px; } }

        .section-header .text-green { color: #166534; }

        .section-line {
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #22c55e, #166534);
          border-radius: 4px;
          margin: 20px auto;
        }

        .section-header p {
          font-size: 16px;
          color: #666666;
          max-width: 680px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .chairman-card {
          background: linear-gradient(135deg, #0a2e1f, #14532d);
          border-radius: 32px;
          padding: 52px;
          display: grid;
          grid-template-columns: 200px 1fr;
          gap: 48px;
          align-items: center;
          margin-bottom: 64px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        }

        @media (max-width: 768px) {
          .chairman-card {
            grid-template-columns: 1fr;
            text-align: center;
            padding: 36px;
            gap: 28px;
          }
        }

        .chairman-image {
          width: 200px;
          height: 200px;
          border-radius: 50%;
          object-fit: cover;
          border: 4px solid #4ade80;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
        }

        @media (max-width: 768px) {
          .chairman-image, .avatar-placeholder { width: 160px; height: 160px; margin: 0 auto; }
          .avatar-placeholder.large span { font-size: 56px; }
        }

        .avatar-placeholder {
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background: linear-gradient(135deg, #4ade80, #166534);
          display: flex;
          align-items: center;
          justify-content: center;
          border: 4px solid #4ade80;
        }
        .avatar-placeholder.large span { font-size: 72px; font-weight: 800; color: white; }

        .chairman-info { position: relative; z-index: 1; color: white; }
        .role-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 16px;
          background: rgba(74, 222, 128, 0.2);
          border: 1px solid rgba(74, 222, 128, 0.5);
          border-radius: 40px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #bbf7d0;
          margin-bottom: 24px;
        }
        .chairman-info h3 { font-size: 38px; margin: 0 0 16px; font-weight: 700; color: white; }
        @media (max-width: 768px) { .chairman-info h3 { font-size: 28px; } }
        .chairman-info p { color: rgba(255, 255, 255, 0.9); margin-bottom: 28px; line-height: 1.6; font-size: 16px; }
        .email-link {
          color: #bbf7d0;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          font-size: 14px;
          padding: 10px 24px;
          background: rgba(255,255,255,0.1);
          border-radius: 40px;
          transition: all 0.2s;
        }

        .committee-sub-tabs {
          display: flex;
          gap: 16px;
          margin-bottom: 40px;
          border-bottom: 2px solid #eef2f0;
          padding-bottom: 0;
        }

        @media (max-width: 768px) {
          .committee-sub-tabs {
            gap: 10px;
            overflow-x: auto;
            flex-wrap: nowrap;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 4px;
          }
        }

        .sub-tab-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 28px;
          background: transparent;
          border: none;
          font-size: 15px;
          font-weight: 600;
          color: #666666;
          cursor: pointer;
          border-radius: 40px 40px 0 0;
          transition: all 0.3s ease;
          position: relative;
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .sub-tab-btn {
            padding: 8px 18px;
            font-size: 13px;
            gap: 8px;
          }
          .sub-tab-btn i { font-size: 13px; }
        }

        @media (max-width: 480px) {
          .sub-tab-btn { padding: 8px 14px; font-size: 12px; gap: 6px; }
          .sub-tab-btn i { font-size: 11px; }
        }

        .sub-tab-btn:hover { color: #166534; background: #f0fdf4; }
        .sub-tab-btn.active { color: #166534; background: linear-gradient(180deg, #f0fdf4 0%, white 100%); }
        .sub-tab-indicator {
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: #22c55e;
          border-radius: 3px;
        }

        @media (max-width: 480px) { .sub-tab-indicator { height: 2px; } }

        .panel-header { margin-bottom: 32px; }
        .panel-header h3 {
          font-size: 28px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        @media (max-width: 768px) { .panel-header h3 { font-size: 24px; } }
        .panel-header p { font-size: 15px; color: #666666; line-height: 1.6; }

        .members-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 28px;
        }
        @media (max-width: 768px) { .members-grid { gap: 20px; } }
        @media (max-width: 640px) { .members-grid { grid-template-columns: 1fr; } }

        .member-card {
          background: white;
          border: 1px solid #eef2f0;
          border-radius: 24px;
          padding: 24px;
          display: flex;
          align-items: center;
          gap: 20px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          min-height: 130px;
        }
        @media (max-width: 480px) { .member-card { padding: 18px; gap: 15px; } }
        .member-card:hover { border-color: #22c55e; box-shadow: 0 20px 35px -12px rgba(15, 46, 31, 0.15); }
        .member-avatar {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: linear-gradient(135deg, #166534, #22c55e);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        @media (max-width: 480px) { .member-avatar { width: 52px; height: 52px; } }
        .member-avatar span { font-size: 24px; font-weight: 700; color: white; }
        @media (max-width: 480px) { .member-avatar span { font-size: 18px; } }
        .member-info h4 { font-size: 18px; font-weight: 700; margin: 0 0 6px; color: #111827; }
        @media (max-width: 480px) { .member-info h4 { font-size: 16px; } }
        .member-info p { font-size: 13px; color: #666666; margin: 0 0 10px; }
        .small-email {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #166534;
          font-size: 12px;
          text-decoration: none;
          font-weight: 500;
        }

        .timetable-wrapper {
          background: white;
          border: 1px solid #eef2f0;
          border-radius: 24px;
          overflow-x: auto;
        }
        .timetable { width: 100%; border-collapse: collapse; min-width: 600px; }
        .timetable th {
          background: linear-gradient(135deg, #0a2e1f, #14532d);
          color: white;
          padding: 16px 24px;
          text-align: left;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .timetable td { padding: 14px 24px; border-top: 1px solid #f0f2f0; color: #4a5568; }
        @media (max-width: 768px) { .timetable th, .timetable td { padding: 12px 16px; } }
        .highlight-row td { background: rgba(34, 197, 94, 0.06); border-left: 3px solid #22c55e; }
        .date-cell { font-weight: 700; color: #166534; white-space: nowrap; }

        .guidelines-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 32px;
        }
        @media (max-width: 900px) { .guidelines-grid { grid-template-columns: 1fr; gap: 24px; } }
        .guideline-card {
          background: white;
          border: 1px solid #eef2f0;
          border-radius: 28px;
          padding: 32px;
          transition: all 0.3s;
        }
        @media (max-width: 768px) { .guideline-card { padding: 24px; } }
        .guideline-card:hover { border-color: #22c55e; box-shadow: 0 20px 35px -12px rgba(15, 46, 31, 0.12); }
        .guideline-number {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 22px;
          color: #166534;
          margin-bottom: 24px;
        }
        .guideline-card h3 { font-size: 20px; font-weight: 700; margin: 0 0 20px; color: #111827; }
        .guideline-content p { font-size: 14px; color: #4a5563; line-height: 1.6; margin: 10px 0; }
        .bullet-point { color: #22c55e; font-weight: 700; margin-right: 10px; display: inline-block; }
        .download-section { text-align: center; margin-top: 60px; }

        .contact-section {
          background: linear-gradient(180deg, #f8faf8 0%, #ffffff 100%);
          padding: 80px 0;
        }
        @media (max-width: 768px) { .contact-section { padding: 60px 0; } }
        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
          margin-top: 48px;
        }
        @media (max-width: 768px) { .contact-grid { grid-template-columns: 1fr; gap: 24px; } }
        .contact-card {
          background: white;
          border-radius: 28px;
          padding: 36px 24px;
          text-align: center;
          border: 1px solid #eef2f0;
          transition: all 0.3s;
        }
        .contact-card:hover { border-color: #22c55e; box-shadow: 0 25px 45px -15px rgba(15, 46, 31, 0.15); transform: translateY(-3px); }
        .contact-avatar {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: linear-gradient(135deg, #166534, #22c55e);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }
        @media (max-width: 480px) { .contact-avatar { width: 80px; height: 80px; } }
        .contact-avatar span { font-size: 36px; font-weight: 800; color: white; }
        @media (max-width: 480px) { .contact-avatar span { font-size: 28px; } }
        .contact-card h4 { font-size: 20px; font-weight: 700; margin: 0 0 6px; color: #111827; }
        .contact-role { font-size: 12px; font-weight: 600; color: #22c55e; letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 20px; }
        .contact-email {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: #f8faf8;
          border-radius: 60px;
          font-size: 12px;
          color: #374151;
          text-decoration: none;
          transition: all 0.2s;
        }
        .contact-email:hover { background: #22c55e; color: white; }
      `}</style>
    </div>
  );
};

export default Election2026;